﻿import { ValgStateActionTypes, TOGGLE_VILKAR, ToggleVilkarAction, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederIofAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import AInntektValg from '../../Utilities/A-InntektValg';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederIofAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederIofAppState, {}, AnyAction>, getState: () => VeilederIofAppState): void => {
        const currentState = getState();
        const visResultat = visR(currentState);
        const visEkstraboks = visE(currentState);

        dispatch(setVisning({ visResultat, visEkstraboks }));
    };
};

const getA = (state: ValgState): string | undefined => {
    return state.aInntekt?.value;
};

const visR = (state: VeilederIofAppState): boolean => {
    return getA(state.valg) !== undefined;
};

const visE = (state: VeilederIofAppState): boolean => {
    return getA(state.valg) === AInntektValg.a1_egenInntekt || getA(state.valg) === AInntektValg.a5_trygd;
};
